import styled from 'styled-components';

const StyledHeader = styled.div`
  > div {
    > div + div {
      > div + div {
        > div {
          padding: 0;

          > div {
            > div > div {
              align-items: flex-start;
              > div {
                z-index: 100;
              }
            }
          }

          + span {
            display: none;
          }

          > a {
            min-width: 53px;
          }
        }

        > span {
          background-color: var(--grey10);
        }
      }
    }
    
    label {
      font-size: 14px;
      font-weight: normal;
    }
  }
`;

export const LinksContainer = styled.ul`
  margin: 0;
  padding: 0;

  a {
      font-size: 18px;
      text-decoration: none;
      color: var(--charcoal);
      font-weight: bold;
      padding: 1px 8px 5px 8px;
      margin: 0 5px;
  }
`;

export default {
  StyledHeader,
  LinksContainer,
};
